<template>
    <div v-if="bookInsight" class="reader-header">
        <div v-observe-visibility="playerVisibilityChanged" class="container">
            <category-pill>
                <template #category-name>
                    Book Insight
                </template>
            </category-pill>
            <h1 class="title">
                {{ bookInsight.title }}
            </h1>
            <h6 class="author">
                {{ authorsNames.join(", ") }}
            </h6>
            <player-interface />
            <div class="row credits">
                <div v-for="credit in bookInsight.credits" :key="credit.collaborator_role.name + credit.collaborator.id" class="col-12 col-md-6 col-lg-4">
                    <person-role-pill :credit="credit" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "ReaderHeader",
    components: {
        playerInterface: () => import(/* webpackChunkName: "player-interface"*/ "@c/audio-player/player-interface"),
        categoryPill: () => import(/* webpackChunkName: "category-pill"*/ "@c/books-insights/category-pill"),
        personRolePill: () => import(/* webpackChunkName: "person-role-pill"*/ "@c/books-insights/person-role-pill")
    },
    computed: {
        ...mapState({
            bookInsight: state => state.NonfictionReader.bookInsight,
            originalAudiobook: state => state.NonfictionReader.originalAudiobook
        }),
        authorsNames() {
            return this.bookInsight.authors.map((author) => author.name);
        }
    },
    methods: {
        playerVisibilityChanged(value = false) {
            this.$emit("show-bottom-nav", !value);
        }
    }
}
</script>

<style lang="scss">
.reader-header {
    background-color: $dark-gray;
    padding: 100px 0;
    padding-bottom: 10px;

    @media (max-width: $md) {
        padding: 140px 0;
        padding-bottom: 10px;
    }

    .category-pill {
        color: white;
        background-color: $medium-gray;
        font-weight: 600;
        margin: 0 auto;
        margin-bottom: 25px;
    }

    .title {
        color: white;
        font-size: 46px;
        font-weight: 600;
        line-height: 56px;
        margin-bottom: 0;
        text-align: center;

        @media (max-width: $md) {
            font-size: 23px;
            line-height: 28px;
        }
    }

    .author {
        color: white;
        font-size: 23px;
        line-height: 32px;
        margin-bottom: 50px;
        text-align: center;

        @media (max-width: $md) {
            font-size: 18px;
            line-height: 16px;
        }
    }

    .reader-player {
        margin-bottom: 45px;

        @media (max-width: $md) {
            .burger-menu {
                padding-left: 15px;
                padding-right: 15px;

                svg {
                    width: 24px;
                }
            }

            .play-button {
                padding-left: 0 !important;

                .play-button-bg {
                    width: 42px !important;
                    height: 42px !important;

                    svg {
                        width: 30px;
                    }
                }
            }

            .theme-name small, .rewind, .forward, .speed {
                display: none;
            }
        }
    }

    .credits-title {
        color: #111111;
        font-family: "Gibson";
        font-size: 21px;
        font-weight: 600;
        line-height: 41px;
        margin-bottom: 20px;
    }

    .credits {
        .person-role-pill {
            margin-bottom: 20px;
            border: 1px solid rgba(0,0,0,0.1);
            width: 100%;
            height: 70px;

            .person-picture {
                width: 70px;
            }
        }
    }
}
</style>
